// extracted by mini-css-extract-plugin
export default {"downloads":"Downloads_downloads__fx3Ft","title":"Downloads_title__92BXy","subtitle":"Downloads_subtitle__s6W5T"};